import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SectionHeader } from '../components/ui/SectionHeader';
import { ChevronLeft } from 'lucide-react';

export const LegalNotice: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="py-12">
      <div className="container mx-auto px-6 max-w-4xl">
        <button 
            onClick={() => navigate(-1)}
            className="group flex items-center gap-2 mb-8 text-gray-300 hover:text-white transition-colors"
        >
            <ChevronLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
            <span className="text-xs font-bold uppercase tracking-widest">Back</span>
        </button>
        
        <div className="bg-black/60 backdrop-blur-md border border-white/10 p-8 md:p-12">
            <SectionHeader subtitle="Legal" title="Legal Notice" />

            <div className="prose prose-invert max-w-none prose-p:text-slate-300 prose-headings:text-white prose-a:text-astral-purple prose-strong:text-white">
                <p>Information according to international commercial regulations.</p>
                
                <h2>Entity Responsible for Content</h2>
                <p>
                    <strong>AstralVibe</strong><br/>
                    Via Squarciabocconi 19/c<br/>
                    51017 Pescia (PT)<br/>
                    Italy
                </p>

                <h2>Contact Information</h2>
                <p>
                    <strong>Telephone:</strong> +39 379 332 2871<br/>
                    <strong>Email:</strong> booking@astralvibe.art<br/>
                    <strong>Website:</strong> astralvibe.art
                </p>
                
                <h2>Represented By</h2>
                <p>The Management</p>

                <h2>Disclaimer</h2>
                
                <h3>Liability for Content</h3>
                <p>
                    The contents of our pages have been created with the utmost care. However, we cannot guarantee the contents' accuracy, completeness, or topicality. According to statutory provisions, we are furthermore responsible for our own content on these web pages. In this context, please note that we are accordingly not obliged to monitor merely the transmitted or saved information of third parties, or investigate circumstances pointing to illegal activity.
                </p>

                <h3>Liability for Links</h3>
                <p>
                    Responsibility for the content of external links (to web pages of third parties) lies solely with the operators of the linked pages. No violations were evident to us at the time of linking. Should any legal infringement become known to us, we will remove the respective link immediately.
                </p>
                
                <h3>Copyright</h3>
                <p>
                    Our web pages and their contents are subject to international copyright law. Unless expressly permitted by law, every form of utilizing, reproducing, or processing works subject to copyright protection on our web pages requires the prior consent of the respective owner of the rights. Individual reproductions of a work are allowed only for private use. The materials from these pages are copyrighted and any unauthorized use may violate copyright laws.
                </p>

                <h3>Online Dispute Resolution</h3>
                <p>
                    The European Commission provides a platform for online dispute resolution (ODR): <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a>. We are not obliged or willing to participate in dispute resolution proceedings before a consumer arbitration board.
                </p>
            </div>
        </div>
      </div>
    </div>
  );
};